const MAPPED_KINDS = new Set([
    "network",
    "validation",
    "unauthorized",
    "forbidden",
    "not_found",
    "conflict",
    "rate_limited",
    "server",
    "contract",
]);

const DEFAULT_MESSAGES = {
    network: "Не удалось связаться с сервером. Проверьте соединение.",
    validation: "Проверьте введенные данные.",
    unauthorized: "Сессия завершена. Войдите снова.",
    forbidden: "У вас нет доступа к финансовой операции.",
    not_found: "Финансовая запись не найдена.",
    conflict: "Запись изменилась. Обновите данные и повторите действие.",
    rate_limited: "Слишком много запросов. Повторите позже.",
    server: "Сервис временно недоступен. Повторите позже.",
    contract: "Некорректный ответ сервера.",
};

const safeIdentifier = (value) =>
    typeof value === "string" && /^[a-z0-9_.:-]+$/i.test(value) ? value : null;

const safeMessage = (value) => {
    if (typeof value !== "string") return null;
    const normalized = value.trim();
    return normalized && normalized.length <= 500 && !/[<>]/.test(normalized) ? normalized : null;
};

const safeFieldErrors = (value) => {
    if (!value || typeof value !== "object" || Array.isArray(value)) return {};
    return Object.entries(value).reduce((result, [key, messages]) => {
        if (!Array.isArray(messages)) return result;
        const safeMessages = messages.map(safeMessage).filter(Boolean);
        if (safeMessages.length > 0) result[key] = safeMessages;
        return result;
    }, {});
};

const kindForStatus = (status) => {
    if (status === 400 || status === 422) return "validation";
    if (status === 401) return "unauthorized";
    if (status === 403) return "forbidden";
    if (status === 404) return "not_found";
    if (status === 409) return "conflict";
    if (status === 429) return "rate_limited";
    return "server";
};

export const mapFinanceError = (error) => {
    if (error && MAPPED_KINDS.has(error.kind) && typeof error.message === "string") {
        return {
            kind: error.kind,
            code: safeIdentifier(error.code),
            message: safeMessage(error.message) || DEFAULT_MESSAGES[error.kind],
            fieldErrors: safeFieldErrors(error.fieldErrors),
            requestId: safeIdentifier(error.requestId),
            retryable: Boolean(error.retryable),
            uncertain: Boolean(error.uncertain),
        };
    }

    if (!error?.response) {
        return {
            kind: "network",
            code: null,
            message: DEFAULT_MESSAGES.network,
            fieldErrors: {},
            requestId: null,
            retryable: true,
            uncertain: true,
        };
    }

    const {status} = error.response;
    const data =
        error.response.data &&
        typeof error.response.data === "object" &&
        !Array.isArray(error.response.data)
            ? error.response.data
            : {};
    const kind = kindForStatus(Number(status));
    const retryable = kind === "rate_limited" || Number(status) >= 500;
    const canUseResponseMessage = ["validation", "conflict", "rate_limited"].includes(kind);

    return {
        kind,
        code: safeIdentifier(data.code),
        message: (canUseResponseMessage ? safeMessage(data.message) : null) || DEFAULT_MESSAGES[kind],
        fieldErrors: safeFieldErrors(data.field_errors),
        requestId: safeIdentifier(data.request_id),
        retryable,
        uncertain: Number(status) >= 500,
    };
};
